'use strict';

module.exports = require('./timers').setTimeout;


/*****************
 ** WEBPACK FOOTER
 ** ./src/common/utils/set-timeout.js
 ** module id = 627
 ** module chunks = 0
 **/